import { Observable } from "rxjs/Observable"

import {
    DIMENSION_ITEM_REQUEST,
    DIMENSION_ITEM_RESPONSE,
    DIMENSION_ITEM_CACHED_RESPONSE,
    DIMENSION_ITEM_ERROR_RESPONSE,
    DIMENSION_ITEM_SAVE_REQUEST,
    DIMENSION_ITEM_SAVE_RESPONSE,
    DIMENSION_ITEM_SAVE_ERROR_RESPONSE,
    DIMENSION_LIST_REQUEST,
    DIMENSION_LIST_RESPONSE,
    DIMENSION_LIST_CACHED_RESPONSE,
    DIMENSION_LIST_ERROR_RESPONSE,
    DIMENSION_LIST_COUNT_REQUEST,
    DIMENSION_LIST_COUNT_RESPONSE,
    DIMENSION_LIST_COUNT_CACHED_RESPONSE,
    DIMENSION_LIST_COUNT_ERROR_RESPONSE,
    DIMENSION_WIZARD_REQUEST,
    DIMENSION_WIZARD_RESPONSE,
    DIMENSION_WIZARD_ERROR_RESPONSE
} from "../actions/action-types"
import {
    dimensionItemResponse,
    dimensionItemSaveResponse,
    dimensionItemCachedResponse,
    dimensionItemErrorResponse,
    dimensionItemSaveErrorResponse,
    dimensionListResponse,
    dimensionListCachedResponse,
    dimensionListErrorResponse,
    dimensionListCountResponse,
    dimensionListCountCachedResponse,
    dimensionListCountErrorResponse,
    dimensionWizardResponse,
    dimensionWizardErrorResponse
} from "../actions/dimension-actions"

import {
    getDimensionItem,
    getDimensionList,
    getDimensionListCount,
    putDimensionItem,
    postDimensionItem
} from "../api/dimension-api"
import { conceptWizard } from "../api/concept-api"
import {
    requestItemEpic,
    requestItemSaveHandler,
    requestItemSaveWithPlaceholdersEpic,
    requestListEpic,
    requestListCountEpic,
    callbackActionCreatorEpic
} from "./default-epics/default-entity-epics"
import { unauthenticated } from "../actions/authentication-actions"
import { mapRequestError } from "./default-epics/epic-utils"
import {
    normalisingFields,
    hydrate as hydrateDimension
} from "../models/entities/dimension"

export const requestDimensionItemEpic = requestItemEpic(
    DIMENSION_ITEM_REQUEST,
    getDimensionItem,
    "dimensions",
    hydrateDimension,
    normalisingFields,
    dimensionItemResponse,
    dimensionItemCachedResponse,
    dimensionItemErrorResponse
)

export const requestDimensionListEpic = requestListEpic(
    DIMENSION_LIST_REQUEST,
    getDimensionList,
    "dimensions",
    dimensionListResponse,
    dimensionListCachedResponse,
    dimensionListErrorResponse
)

export const requestDimensionListCountEpic = requestListCountEpic(
    DIMENSION_LIST_COUNT_REQUEST,
    getDimensionListCount,
    "dimensionCount",
    dimensionListCountResponse,
    dimensionListCountCachedResponse,
    dimensionListCountErrorResponse
)

const requestDimensionItemSaveHandler = requestItemSaveHandler(
    putDimensionItem,
    postDimensionItem,
    "dimension",
    dimensionItemSaveResponse,
    dimensionItemSaveErrorResponse
)

export const requestDimensionItemSaveEpic = requestItemSaveWithPlaceholdersEpic(
    DIMENSION_ITEM_SAVE_REQUEST,
    requestDimensionItemSaveHandler,
    "dimension"
)

export const requestDimensionWizardEpic = (action$, { getState }) =>
    action$
        .ofType(DIMENSION_WIZARD_REQUEST)
        .switchMap(({ type, callbackActionCreator, ...partialDimension }) =>
            conceptWizard(getState().authentication.token, partialDimension)
                .map(data =>
                    dimensionWizardResponse(data, false, callbackActionCreator)
                )
                .catch(error =>
                    Observable.of(
                        mapRequestError(
                            error,
                            unauthenticated,
                            dimensionWizardErrorResponse,
                            partialDimension,
                            callbackActionCreator
                        )
                    )
                )
        )

export const responseDimensionCallbackEpic = callbackActionCreatorEpic(
    DIMENSION_ITEM_RESPONSE,
    DIMENSION_ITEM_SAVE_RESPONSE,
    DIMENSION_ITEM_SAVE_ERROR_RESPONSE,
    DIMENSION_ITEM_CACHED_RESPONSE,
    DIMENSION_ITEM_ERROR_RESPONSE,
    DIMENSION_WIZARD_RESPONSE,
    DIMENSION_WIZARD_ERROR_RESPONSE,
    DIMENSION_LIST_RESPONSE,
    DIMENSION_LIST_CACHED_RESPONSE,
    DIMENSION_LIST_ERROR_RESPONSE,
    DIMENSION_LIST_COUNT_RESPONSE,
    DIMENSION_LIST_COUNT_CACHED_RESPONSE,
    DIMENSION_LIST_COUNT_ERROR_RESPONSE
)
